import { Warning } from '@mui/icons-material';
import { FC, MouseEventHandler, useCallback, useState } from 'react';

import { TireInspection } from 'pages/new-transaction/tires';
import ImageViewer from './image';

const TireColumn: FC<{
  centrality: TireInspection['centrality'];
  side: TireInspection['side'];
  tires: Partial<TireInspection>[];
}> = ({ centrality, side, tires }) => {
  const [notesClass, setNotesClass] = useState('notes text-ellipsis');
  const toggleNotes: MouseEventHandler<HTMLParagraphElement> = useCallback(() => {
    setNotesClass(p => (!p.includes('text-ellipsis') ? 'notes text-ellipsis' : 'notes'));
  }, [setNotesClass]);
  const { FRONT, CENTER, REAR }: { [P in TireInspection['axle']]: JSX.Element[] } = tires.reduce(
    (acc, val, i) => {
      if (val.axle && val.centrality === centrality && val.side === side) {
        if (val.damageType)
          acc[val.axle].push(
            <p key={`damageType-${i}`} className="d-flex">
              <Warning color="secondary" fontSize="small" />
              {val.damageType}
            </p>
          );
        if (val.measurement0 !== null)
          acc[val.axle].push(
            <p key={`measurement0-${i}`} className="ws-n3">
              {val.measurement0} / 32
            </p>
          );
        if (val.measurement1 !== null)
          acc[val.axle].push(
            <p key={`measurement1-${i}`} className="ws-n3">
              {val.measurement1} / 32
            </p>
          );
        if (val.measurement2 !== null)
          acc[val.axle].push(
            <p key={`measurement2-${i}`} className="ws-n3">
              {val.measurement2} / 32
            </p>
          );

        if (val.notes?.length)
          acc[val.axle].push(
            <p key={`notes-${i}-${notesClass}`} className={notesClass} onClick={toggleNotes}>
              {val.notes}
            </p>
          );
        if (val.imageKey) {
          acc[val.axle].push(<ImageViewer images={[val]}>VIEW TIRE</ImageViewer>);
        }
      }
      return acc;
    },
    { FRONT: [] as JSX.Element[], CENTER: [] as JSX.Element[], REAR: [] as JSX.Element[] }
  );
  return (
    <div className="tire-column">
      <h6 className="primary-dark font-weight-medium">
        {centrality === 'INNER' ? 'INSIDE' : 'OUTSIDE'} {side}
      </h6>
      <div className="grid-1 p-2">
        <div>
          <h6 className="text-dark font-weight-regular">FRONT</h6>
          <p className="text-black">{!FRONT.length ? 'N/A' : FRONT}</p>
        </div>
        <div>
          <h6 className="text-dark font-weight-regular">CENTER</h6>
          <p className="text-black">{!CENTER.length ? 'N/A' : CENTER}</p>
        </div>
        <div>
          <h6 className="text-dark font-weight-regular">REAR</h6>
          <p className="text-black">{!REAR.length ? 'N/A' : REAR}</p>
        </div>
      </div>
    </div>
  );
};

export const TireDetails: FC<{ tires: TireInspection[] }> = (props: { tires: TireInspection[] }) => {
  return (
    <div className="card-primary">
      <div className="card-header px-3">
        <h4>TIRE SUMMARY</h4>
      </div>
      <div className="card-body grid-4" id="tire-grid">
        <TireColumn centrality="OUTER" side="LEFT" tires={props.tires} />
        <TireColumn centrality="INNER" side="LEFT" tires={props.tires} />
        <TireColumn centrality="INNER" side="RIGHT" tires={props.tires} />
        <TireColumn centrality="OUTER" side="RIGHT" tires={props.tires} />
      </div>
    </div>
  );
};

export default TireDetails;
